import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import { AppInnerWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import useBeforeUnload from '@rsos/utils/useBeforeUnload';
import useBrowserRefresh from '@rsos/utils/useBrowserRefresh';
import initialize from '../actions/initialize';
import AgencyInfoForm from '../components/AgencyInfoForm/';
import DataSourceBanner from '../components/DataSourceBanner';
import JurisdictionDetails from '../components/JurisdictionDetails/';
import { persistor } from '../store';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const App = () => {
  const dispatch = useDispatch();
  let location = useLocation();

  const { initializing, initialized, error } = useSelector(state => state.app);
  const { application } = useSelector(state => state.sinatra.user.currentRole);
  const isCapstone = application === 'capstone';

  useBrowserRefresh();
  useBeforeUnload();
  useInitialize(dispatch);

  return useMemo(() => {
    if (error) {
      return <ErrorPage persistor={persistor} />;
    }
    if (initializing) {
      return <AppLoading />;
    }
    if (initialized) {
      return (
        <AppInnerWrapper>
          <DataSourceBanner />
          <AgencyInfoForm pathname={location.pathname} />
          {isCapstone && <JurisdictionDetails pathname={location.pathname} />}
        </AppInnerWrapper>
      );
    }
    return <ErrorPage persistor={persistor} />;
  }, [initializing, initialized, error, location, isCapstone]);
};
export default App;
